import { useContext } from 'react';
import getIn from 'immutable-less/transmute/getIn';
import { AuthContext, getLimit, hasScope, isUngated } from 'automation-ui-core/context/AuthContext';
export const useIsUngated = gate => {
  const authContext = useContext(AuthContext);
  return isUngated(authContext.gates)(gate);
};
export const useHasScope = scope => {
  const authContext = useContext(AuthContext);
  return hasScope(authContext.user.scopes)(scope);
};
export const useLimit = limit => {
  const authContext = useContext(AuthContext);
  return getLimit(authContext.portal.limits)(limit);
};
export const useUserId = () => {
  const authContext = useContext(AuthContext);
  return getIn(['user', 'user_id'], authContext);
};

// TODO (SE) - move to automation-ui-management
export const useWorkflowCountLimit = () => {
  return useLimit('workflows');
};
export const useGetIsUngated = () => {
  const authContext = useContext(AuthContext);
  return isUngated(authContext.gates);
};
export const useGetHasScope = () => {
  const authContext = useContext(AuthContext);
  return hasScope(authContext.user.scopes);
};
export const useGetLimit = () => {
  const authContext = useContext(AuthContext);
  return getLimit(authContext.portal.limits);
};